var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 21.0005C24.5 19.6192 23.3808 18.5 22.0005 18.5C20.6192 18.5 19.5 19.6192 19.5 21.0005C19.5 22.3808 20.6192 23.5 22.0005 23.5C23.3808 23.5 24.5 22.3808 24.5 21.0005Z",
    stroke: "#FF5F14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9995 31.5C20.801 31.5 14.5 26.3984 14.5 21.0633C14.5 16.8866 17.8571 13.5 21.9995 13.5C26.1419 13.5 29.5 16.8866 29.5 21.0633C29.5 26.3984 23.198 31.5 21.9995 31.5Z",
    stroke: "#FF5F14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLocation);
export default __webpack_public_path__ + "static/media/smallLocation.ef360b4092dc68e0f7b64bc5e45d0c6f.svg";
export { ForwardRef as ReactComponent };